export default {"src":"/_next/static/media/logo-secondary.4ee944bd.svg","height":72,"width":259,"blurWidth":0,"blurHeight":0};